import React, {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './portfolio.css'

const Portfolio = () => {
    const [portfolio, setPortfolio] = useState([])
    const [error, setError] = useState()
    const [popupData, setPopupData] = useState()
    const navigate = useNavigate();

    const getAllPortfolio = async() =>{
        try{
            const resp = await fetch("/data/db.json")
            if(!resp.ok){
                throw new Error(`Error Encounter: ${resp.error}`)

            }
            const data = await resp.json();
            setPortfolio(data.ProjectsData);
        }catch(err){
            setError(err.message)
        }
    }

    useEffect(()=>{
        getAllPortfolio();
    })

    const openPopup = (project) => {
        setPopupData(project);
    };

    const closePopup = () => {
        setPopupData(null);
    };

    const handleDownload = () =>{
        window.open(popupData.link, '_blank');
    }

    const openIframeComponent = (iframeLink) => {
        navigate(`/iframe/${encodeURIComponent(iframeLink)}`, '_blank');
    };


    return (
        <div className="Portfolio">
            <Helmet>
                {/* Basic Meta */}
                <title>Portfolio | SuperCodingBits</title>
                <meta
                    name="description"
                    content="Explore the portfolio of SuperCodingBits, a React.js developer. Showcasing projects, UI components, and frontend solutions with clean, responsive design."
                />
                <meta
                    name="keywords"
                    content="SuperCodingBits Portfolio, React.js Developer, Frontend Developer, Web Development, UI Components, React Projects, Responsive Design, JavaScript, SCSS, Web Apps, Coding Projects"
                />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href="https://supercodingbitsweb.vercel.app/protfolio" />
                
                {/* Open Graph */}
                <meta property="og:title" content="Portfolio | SuperCodingBits" />
                <meta property="og:description" content="Explore the portfolio of SuperCodingBits, a React.js developer. Showcasing projects, UI components, and frontend solutions with clean, responsive design." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://supercodingbitsweb.vercel.app/protfolio" />
                <meta property="og:image" content="https://supercodingbitsweb.vercel.app/cheatsheet-preview.jpg" />
                
                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Portfolio | SuperCodingBits" />
                <meta name="twitter:description" content="Explore the portfolio of SuperCodingBits, a React.js developer. Showcasing projects, UI components, and frontend solutions with clean, responsive design." />
                <meta name="twitter:image" content="https://supercodingbitsweb.vercel.app/cheatsheet-preview.jpg" />
            </Helmet>
            
            <div className="subPortfolio">
                {portfolio.map((project) => (
                    <div className="card" key={project.id}>
                        <div
                            className="img"
                            onClick={() => openPopup(project)}
                            // onClick={() => openIframeComponent(project.iframeLink)}
                            title={project.title}
                        >
                            <img src={project.image} alt={project.title} />
                        </div>
                    </div>
                ))}
            </div>

            {popupData && (
                <div className="Portfoliopopup">
                    <div className="PortfoliopopupContent">
                        <button className="ProjectcloseButton" onClick={closePopup}>
                            &times;
                        </button>
                        <h2>{popupData.title}</h2>
                        <iframe
                            src={popupData.iframeLink || popupData.link}
                            title={popupData.title}
                            frameBorder="0"
                            allowFullScreen
                        ></iframe>
                        <button onClick={handleDownload} className='DownloadBtn'>Download</button>
                        <button onClick={openIframeComponent} className='DownloadBtn'>New Window</button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Portfolio